import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private http: CustomHttpService
  ) { }

  getAllDepartment(body:any): Observable<any> {
    return this.http.post(environment.getAllDepartment,body);
  }

  getAllRoles(body:any): Observable<any> {
    return this.http.post(environment.getAllRoles,body);
  }

  updateUser(body:any): Observable<any> {
    return this.http.post(environment.updateUser,body);
  }

  getUser(data:any): Observable<any> {
    return this.http.post(environment.getUser,data);
  }

  findAllUsers(body:any): Observable<any> {
    return this.http.post(environment.findAllUsers,body);
  }

  getAllUsers(body:any): Observable<any> {
    return this.http.post(environment.getAllUsers,body);
  }

  createUser(body:any): Observable<any> {
    return this.http.post(environment.createUser,body);
  }

  getAllDepartmentsWithCount(body: any): Observable<any> {
    return this.http.post(environment.getAllDepartmentsWithCount, body);
  }

  createDepartment(body: any): Observable<any> {
    return this.http.post(environment.createDepartment, body);
  }

  updateDepartment(body : any): Observable<any> {
    return this.http.post(environment.updateDepartment, body);
  }

  deleteDepartment(body: any): Observable<any> {
    return this.http.post(environment.deleteDepartment, body);
  }
}
